<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="approver-list"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1 class="p-modal-head01__title" id="approver-list" [innerHTML]="'label.approverList' | staticMsg"></h1>

      <button
        id="anabiz-payment-input-approver-list-close-btn"
        class="p-modal-head01__close js-modal-close"
        (click)="this.close()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
    <div *ngIf="!isSp || (isSp && swipeDirection === 'up')" class="approver-list-search-box">
      <div class="c-form-element-input__box approver-search-box">
        <div style="width: 100%">
          <label class="c-form-element-input__wrap" for="anabiz-payment-input-approver-list-search-input">
            <span class="c-form-element-input__label">
              <span
                class="c-form-element-input__label-text"
                [innerHTML]="'label.approverName.payment' | staticMsg"
              ></span>
            </span>
          </label>
          <span class="c-form-element-input__input">
            <input
              id="anabiz-payment-input-approver-list-search-input"
              [(ngModel)]="searchText"
              type="text"
              maxlength="30"
              class="c-form-element-input__input-item"
              [attr.placeholder]="'placeholder.approverName' | staticMsg"
            />
          </span>
        </div>
        <img
          src="assets/images/icon_search_24.svg"
          width="24"
          height="24"
          [attr.alt]="'alt.approverSerch' | staticMsg"
        />
      </div>
    </div>
  </div>

  <div #modalBody id="anabiz-payment-approver-list-body" [class]="lmodalBodyClass" class="approver-list-body">
    <ng-container *ngFor="let item of filteredItems; index as i">
      <div class="p-booking-info-mdl__item select-approver">
        <button
          id="anabiz-payment-input-approver-list-select-approver-{{ i }}"
          class="p-booking-info-mdl__open"
          (throttleClick$)="selectApprover(item)"
          aswThrottleClick
        >
          <span class="p-booking-info-mdl__open-head">
            <span class="p-booking-info-mdl__open-title" [innerHtml]="item.name"></span>
            <span class="p-booking-info-mdl__open-subtext" [innerHtml]="item.emailAddress"></span>
          </span>
          <span class="l-tab-menu01__change-title-icon approver-modal-approver-button"> </span>
        </button>
      </div>
    </ng-container>

    <div *ngIf="!hasData">
      <div class="p-booking-info-mdl__open">
        <div class="no-approver-message-box" [innerHtml]="'alt.noApprover' | staticMsg"></div>
      </div>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass"></div>
</div>
